import React, { useState } from 'react'
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Typography,
} from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import useCustomerSublocations from '../hooks/useCustomerSublocations'

function CustomerSublocations({
  open,
  onClose,
  customerLocationId,
  initialSublocations,
  onSublocationsChange,
}) {
  const [inputValue, setInputValue] = useState('')
  const { sublocations, addSublocation, removeSublocation, isAdding, isRemoving } =
    useCustomerSublocations({ customerLocationId, initialSublocations, onSublocationsChange })

  const handleAdd = () => {
    const trimmed = inputValue.trim()
    if (!trimmed) {
      return
    }
    addSublocation(trimmed, {
      onSuccess: () => setInputValue(''),
    })
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleAdd()
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Manage Sublocations</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Additional FactSet location IDs that map to this customer.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            mb: 2,
            minHeight: theme => theme.spacing(5),
          }}
        >
          {sublocations.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No sublocations yet.
            </Typography>
          )}
          {sublocations.map(s => (
            <Chip
              key={s.id}
              label={s.sublocationId}
              onDelete={isRemoving ? undefined : () => removeSublocation(s.id)}
            />
          ))}
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            label="Sublocation ID"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            size="small"
            fullWidth
            disabled={isAdding}
          />
          <Button onClick={handleAdd} disabled={isAdding || !inputValue.trim()}>
            Add
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default CustomerSublocations
